import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LiveHelpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"live_help"}/>
}
